import { Navbar } from '../../components';
import { useNavigate } from 'react-router-dom';
import { SinglePaymentResult } from './components/form-single-payment/SinglePaymentResult';
import { useSinglePaymentResultState } from './components/form-single-payment/useSinglePaymentResultState';
import { buildSinglePaymentFormPath } from './components/form-single-payment/singlePaymentSession';
import { getLegacyPaymentRetryPath } from './paymentFlowFallback';

type RejectType = {
  text?: string;
};

export const RejectPaymentPage = ({
  text = 'Algo salió mal, por favor inténtalo nuevamente o contáctanos'
}: RejectType) => {
  const navigate = useNavigate();
  const legacyRedirectPath = getLegacyPaymentRetryPath();
  const {
    errorMessage,
    hasSinglePaymentContext,
    isLoading,
    payment,
    singlePaymentId
  } = useSinglePaymentResultState();

  const handleRestart = () => {
    if (!legacyRedirectPath) {
      return;
    }

    navigate(legacyRedirectPath);
  };

  return (
    <>
      <Navbar />
      {hasSinglePaymentContext ? (
        <div
          className="pt-20 pb-20 sm:pt-[7rem] sm:pb-[7rem] px-4 sm:px-6 lg:px-10 w-full h-auto min-h-screen flex justify-center"
          style={{ background: '#F9F9F9' }}
        >
          <SinglePaymentResult
            errorMessage={errorMessage}
            isLoading={isLoading}
            onRetry={
              singlePaymentId
                ? () => navigate(buildSinglePaymentFormPath(singlePaymentId))
                : null
            }
            payment={payment}
            status={payment?.status}
          />
        </div>
      ) : (
      <div
        className="pt-48 p-10 w-full h-auto min-h-screen flex justify-center"
        style={{ background: '#F9F9F9' }}
      >
        <div className={'flex flex-col items-center'}>
          <img
            src={require('../../assets/images/pago_rechazado.png')}
            className={'my-5'}
            alt={'pago_rechazado'}
          />
          <h1 className={'text-4xl w-10/12 text-center'}>{text}</h1>
          <div className={'flex mt-5'}>
            <button
              className={
                'bg-green-500 hover:bg-green-400 text-white font-medium px-7 py-1 rounded-xl flex mx-10'
              }
              onClick={() =>
                window.location.replace(
                  'https://api.whatsapp.com/send/?phone=56951177975&text=Hola%21+Tengo+problemas+con+el+pago&type=phone_number&app_absent=0'
                )
              }
            >
              <div
                className={
                  'bg-no-repeat bg-center bg-cover w-[20px] h-[20px] mx-2'
                }
                style={{
                  backgroundImage: `url(${require('../../assets/images/ico_wsp.png')})`
                }}
              ></div>
              Contactar con Whatsapp
            </button>
            {legacyRedirectPath && (
              <button className="btn" onClick={() => handleRestart()}>
                Reintentar
              </button>
            )}
          </div>
        </div>
      </div>
      )}
    </>
  );
};
